declare namespace $ {

	type $mol_string__hint_shm_dashboard_admin_user_add_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_dashboard_admin_user_add_2 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_add['email'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_user_add_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_dashboard_admin_user_add_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_string__hint_shm_dashboard_admin_user_add_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_dashboard_admin_user_add_6 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_add['name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_user_add_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_dashboard_admin_user_add_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_password__value_shm_dashboard_admin_user_add_9 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_add['password'] >
		,
		ReturnType< $mol_password['value'] >
	>
	type $mol_password__submit_shm_dashboard_admin_user_add_10 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_add['submit'] >
		,
		ReturnType< $mol_password['submit'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_user_add_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_dashboard_admin_user_add_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_button_major__title_shm_dashboard_admin_user_add_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_dashboard_admin_user_add_14 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_add['submit'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_text__text_shm_dashboard_admin_user_add_15 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_add['message'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $shm_dashboard_admin_user_add extends $mol_page {
		email( next?: string ): string
		Email( ): $mol_string
		Email_label( ): $mol_labeler
		name( next?: string ): string
		Name( ): $mol_string
		Name_label( ): $mol_labeler
		password( next?: string ): string
		submit( next?: any ): any
		Password( ): $mol_password
		Password_label( ): $mol_labeler
		Submit( ): $mol_button_major
		message( next?: string ): string
		Message( ): $mol_text
		title( ): string
		created( next?: string ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=add.view.tree.d.ts.map